// extracted by mini-css-extract-plugin
export default {"wrapper":"Countdown_wrapper__PXUt9","visible":"Countdown_visible__HbuNb","warning":"Countdown_warning__JHsk2"};